import Route from '@ember/routing/route'
import { service } from '@ember/service'
import type ContentfulClientService from 'teacher-ui-client/services/contentful-client'
import type SubscriptionTypeRoute from 'teacher-ui-client/subscription-type/route'

export default class TeacherResourcesCurriculumMapsRoute extends Route {
  @service contentfulClient!: ContentfulClientService

  async model() {
    const { subscriptionType } = this.modelFor('subscription-type') as ModelFor<SubscriptionTypeRoute>
    const curriculumMaps = await this.contentfulClient.getCurriculumMaps({ subscriptionType })
    return {
      curriculumMaps,
    }
  }
}
